import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pss-load-begin',
  imports: [CommonModule],
  templateUrl: './pss-load-begin.component.html',
  styleUrl: './pss-load-begin.component.css'
})
export class PssLoadBeginComponent {
  animationLogo : number = 1;

  @Input() timeIn : number = 3000
  @Output() close = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => { 
      this.beginLoadingClownDown() 
      this.animationLogo = 2
    }, this.timeIn);
  }

  beginLoadingClownDown(){
    setTimeout(() => {
      this.close.emit(false); 
    },200)

   
    
    //console.log( this.animationLogo );
  }
}
